
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuildoutLogo } from 'helpers/custom_fontawesome_icons';

import {
  fetchRemainingUnlocks,
  unlockPropertyOwners,
} from 'bundles/connect/helpers/connect_api';
import UnlockWithCreditsCard from './unlock_with_credits_card';
import UpgradePlanCard from './upgrade_plan_card';

export default function ContactsUnlockCard({ id, onUnlock }) {
  const [loading, setLoading] = useState(true);
  const [remainingUnlocks, setRemainingUnlocks] = useState(0);

  const getRemainingUnlocks = () => {
    fetchRemainingUnlocks()
      .then(setRemainingUnlocks)
      .catch(() => setRemainingUnlocks(0))
      .finally(() => setLoading(false));
  };

  const handleUnlock = () => unlockPropertyOwners(id).then(onUnlock).catch(console.warn);

  useEffect(() => {
    getRemainingUnlocks();
  }, []);

  if (loading) {
    return (
      <div className="text-center py-4">
        <FontAwesomeIcon
          beatFade
          className="text-primary"
          icon={faBuildoutLogo}
          size="3x"
        />
      </div>
    );
  }

  if (remainingUnlocks === 0) return <UpgradePlanCard onUpgrade={onUnlock} />;

  if (remainingUnlocks > 0)
    return (
      <UnlockWithCreditsCard
        remainingUnlocks={remainingUnlocks}
        onUnlock={handleUnlock}
      />
    );
}

ContactsUnlockCard.propTypes = {
  id: PropTypes.number.isRequired,
  onUnlock: PropTypes.func.isRequired,
};
